<!--
     <MetricEditNumber
       readonly
     />

     Public methods:
       set_value(config) // config = {indicator_uid: 'QUnit#....'}
       get_value() → returns config ↑↑↑
-->

<template>
  <div class="mei-cont">
    <v-select
      v-model="model"
      :items="indicator_items"
      item-text="text"
      item-value="value"
      :label="$vuetify.lang.translator('indicators.indicator_label')"
      return-object
      outlined
      :disabled="readonly || loading"
      size="48"
      :rules="[rule_required]"
      :loading="loading"
      @input="update"
      :class="readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input required'"
    ></v-select>
  </div>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .mei-cont {
   width: 100%;
   display: flex;
   flex-direction: column;
 }
</style>

<script>
 import { mapActions, mapMutations, mapState } from 'vuex'
 import QUnitCollection from '@/qunit/QUnitCollection';
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: 'MetricEditIndicator',

   props: [
     'readonly',
     'value',
     'current_unit'
   ],

   data: () => ({
     loading: false,
     qunits: null,
     model: null,
   }),

   async mounted() {
     this.loading = true;
     const ef = new QFilters({site: this.UserSession.site});
     this.qunits = await QUnitCollection.subindicators(ef);
     this.loading = false;
     if (this.value) {
      this.set_value(this.value)
     }
   },

   computed: {
     ...mapState(['UserSession']),

     indicator_items() {
       if (!this.qunits)
         return [];
       return this.qunits.units.filter(unit => unit.uid != (this.current_unit || {}).uid)
        .map(indi => ({
          text: `${indi.reference} / ${indi.title}`,
          value: indi.uid,
        }))
        .sort((a, b) => a.text.localeCompare(b.text));
     }
   },

   methods: {
     get_value() {
       return this.serialize();
     },

     set_value(config) {
       this.model = {
         'value': config.indicator_uid,
       }
     },

     serialize() {
       return {
         'indicator_uid': this.model.value,
       };
     },

     rule_required(value) {
       // TODO: Multilang: Change hardcoded string
       return !!value || this.$vuetify.lang.translator('required_field');
     },

     update(value) {
      this.$emit('input',this.serialize());
     },
   },
 }
</script>
